import React from 'react';
import { toaster } from '@fiverr-private/fit';
import Toast from '../../components/Toast';

export const TOAST_TYPES = Toast.TYPES;

export const raiseToast = ({ type, content, location = toaster.LOCATIONS.TOP_CENTER } = {}) => {
    toaster.raise(<Toast type={type}>{content}</Toast>, { location });
};
